import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../../utils/hooks/auth';
import { CashFlowIcon, SpacedMinusSign, Typography } from '../../../ui-kit';
import { localizeEnum } from '../../../utils';
import { DeductionReason } from '../../../generated/graphql';
import { usePriceService } from '../../../utils/hooks/priceService';
// import { routePaths } from '../../../routePaths';
import { DeductionAmounts } from './types';
import AccordionRow from './AccordionRow';

interface WriteOffSummaryProps {
    deductionsSummary: DeductionAmounts['withVat'] | DeductionAmounts['withoutVat'];
}

const WriteOffSummary = ({ deductionsSummary }: WriteOffSummaryProps) => {
    const { t } = useTranslation();
    const { priceService } = usePriceService();
    const { user: { defaultCurrency: { currencyCode } } } = useUser();
    const {
        total,
        waste,
        writeOff
    } = deductionsSummary;

    // const linkUrl = routePaths.warehouseDeductionLists;

    return (
        <AccordionRow
            Icon={CashFlowIcon}
            color='red'
            amount={total}
            title={t('Write-off plural')}
            // linkUrl={linkUrl}
            appendMinusToAmount
        >
            <Box display='flex'>
                <Typography variant='body2' fontWeight='medium'>
                    {localizeEnum(t)(DeductionReason.Waste, { DeductionReason })}
                </Typography>
                <Typography variant='body2'>
                    {SpacedMinusSign}
                </Typography>
                <Typography variant='body2'>
                    {priceService.toLocaleString(waste, currencyCode)}
                </Typography>
            </Box>
            <Box display='flex'>
                <Typography variant='body2' fontWeight='medium'>
                    {localizeEnum(t)(DeductionReason.Writeoff, { DeductionReason })}
                </Typography>
                <Typography variant='body2'>
                    {SpacedMinusSign}
                </Typography>
                <Typography variant='body2'>
                    {priceService.toLocaleString(writeOff, currencyCode)}
                </Typography>
            </Box>
        </AccordionRow>
    );
};

export default WriteOffSummary;